import './index.scss'
import ScrollMagic from 'scrollmagic'

window.onload = function () {
  const headFx = window.document.querySelector('.head-content-fx')
  const btns = window.document.querySelector('.head')
  headFx.addEventListener('click', () => {
    if (!btns.classList.contains('active')) {
      window.open('https://preview.functionx.io/', '_blank')
    }
  })
  // const headXw = window.document.querySelector('.head-content-xw')
  // const head = window.document.querySelector('.head')
  // let state = true
  // head.addEventListener('click', () => {
  //   if (state) {
  //     head.classList.add('active')
  //   } else {
  //     head.classList.remove('active')
  //   }
  //   state = !state
  // })
  //
  // const btns = window.document.querySelector('.app-btns')
  // let btnState = true
  // btns.addEventListener('click', () => {
  //   if (btnState) {
  //     btns.classList.add('active')
  //   } else {
  //     btns.classList.remove('active')
  //   }
  //   btnState = !btnState
  // })

  const controller = new ScrollMagic.Controller({
    refreshInterval: 0
  })

  new ScrollMagic.Scene({
    // duration: 100,
    offset: -60,
    triggerElement: '#triggerTitle',
    triggerHook: 'onLeave',
    loglevel: 2
  })
    .setClassToggle('.head', 'active')
    .addTo(controller)

  new ScrollMagic.Scene({
    offset: 96,
    triggerElement: '#triggerFoot',
    triggerHook: 'onEnter',
  })
    .setClassToggle('.app-btns', 'active')
    .addTo(controller)
}
